export const getZoneData = (data, zone) => {

    const baseData = {
        [`${zone}_base_type`]: data[`${zone}_base_type`] || '',
        [`${zone}_should_do_allnum`]: parseInt(data[`${zone}_should_do_allnum`] || '0'),
        [`${zone}_have_do_allnum`]: parseInt(data[`${zone}_have_do_allnum`] || '0'),
        [`${zone}_ships`]: data[`${zone}_ships`] || [],
    };
    
    if (zone === 'z3') {
        return {
            ...baseData,
            [`${zone}_tower_check`]: data[`${zone}_tower_check`] || '0',
            [`${zone}_tower_num`]: parseInt(data[`${zone}_tower_num`] || '0'),
            [`${zone}_cabin_check`]: data[`${zone}_cabin_check`] || '0',
            [`${zone}_cabin_num`]: parseInt(data[`${zone}_cabin_num`] || '0'),
            [`${zone}_blade_check`]: data[`${zone}_blade_check`] || '0',
            [`${zone}_blade_num`]: parseInt(data[`${zone}_blade_num`] || '0'),
            [`${zone}_wind_turbine_check`]: data[`${zone}_wind_turbine_check`] || '0',
            [`${zone}_wind_turbine_num`]: parseInt(data[`${zone}_wind_turbine_num`] || '0'),
        };
    } else if (zone === 'z4') {
        return {
            ...baseData,
            [`${zone}_have_been_grid_conneciton_num`]: parseInt(data[`${zone}_have_been_grid_conneciton_num`] || '0'),
        };
    }
    
    return baseData;
};
